import { OrderItem } from "app/models/order/order-item";
import { CartProduct } from "../cart-product/cart-product";
import { CheckPriceProduct } from "../check-price-product/check-price-product";

export class ChangedPriceProduct {

  newPrice: number;
  orderItem: OrderItem;
  keep: boolean;
  active: boolean;
  stockQuantity: number;
  observation: string;

  static fromJson(json: any): ChangedPriceProduct {
    var temp = new ChangedPriceProduct();
    temp.newPrice = json['NEWPRICE'];
    temp.stockQuantity = json['STOCKQUANTITY'];
    temp.orderItem = OrderItem.fromJson(json);
    temp.keep = undefined;
    temp.active = json['ACTIVE'];
    temp.observation = json['CARTITEMOBSERVATION'];
    return temp;
  }

  static fromCheckPriceProduct(product: CheckPriceProduct, cartProduct: CartProduct): ChangedPriceProduct {
    var temp = new ChangedPriceProduct();
    temp.newPrice = product.newPrice;
    temp.orderItem = OrderItem.fromCheckPriceProduct(product, cartProduct);
    temp.keep = undefined;
    temp.active = product.active;
    return temp;
  }

}
